import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../../../shared/util/util';
import {trackEvent} from '../../../../../tracking/amplitude/TrackingV2';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../../../../mutations/MutationTypes';
import {
	CreateBaselineTemplateInput,
	CreateBaselineTemplateMutation,
} from './__generated__/CreateBaselineTemplateMutation.graphql';

const mutation = graphql`
	mutation CreateBaselineTemplateMutation($input: CreateBaselineTemplateInput!) {
		createBaselineTemplate(input: $input) {
			baselineTemplate {
				id
				name
			}
			company {
				id
				...BaselineTemplatesList_company
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<CreateBaselineTemplateInput>,
	onSuccess?: RelayOnCompleted<CreateBaselineTemplateMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<CreateBaselineTemplateMutation>(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			if (!errors?.length) {
				trackEvent('Baseline Template', 'Created');
			}
			onSuccess?.(response, errors);
		},
		onError: onError,
	});
}

export default {commit};
